$(function () {
    let $banners = $('.banner');
    let total_banners = $banners.length;
    let curr_banner = 1;
    if (total_banners > 0) {
        setInterval(rotateBanner, 3000);
    }

    function rotateBanner() {
        $('.banner.out').removeClass('out');
        $('.banner.active').addClass('out').removeClass('active');
        curr_banner++;
        if (curr_banner > total_banners) {
            curr_banner = 1;
        }
        $('.banner:nth-child(' + curr_banner + ')').addClass('active');
    }
});
